import React from 'react';
import { Modal, Button } from '@mui/material';
import { blue } from '@mui/material/colors';

import * as S from '../Register/styles'; // ایمپورت استایل‌ها از Register/styles.ts
import { ACTION_BLUE, ACTION_BLUE_HOVER } from '../../../theme/theme';

// ثابت‌ها برای اطلاعات پشتیبانی
const SUPPORT_CONTACT = {
  phone: '+98 912 099 8606',
  phoneDisplay: '۰۹۱۲۰۹۹۸۶۰۶',
  whatsapp: 'https://wa.me/+989120998606',
  telegram: 'https://t.me/+989120998606',
};

interface SupportModalProps {
  open: boolean;
  onClose: () => void;
}

const SupportModal: React.FC<SupportModalProps> = ({ open, onClose }) => (
  <Modal open={open} onClose={onClose}>
    <S.ModalContent>
      <S.ModalTitle>تماس با پشتیبانی</S.ModalTitle>
      <S.ModalItem>
        <S.Label>شماره تلفن:</S.Label>
        <S.ClickableTextBlue as="a" href={`tel:${SUPPORT_CONTACT.phone}`}>
          {SUPPORT_CONTACT.phoneDisplay}
        </S.ClickableTextBlue>
      </S.ModalItem>
      <S.ModalItem>
        <S.Label>واتس‌اپ:</S.Label>
        <S.ClickableTextBlue
          as="a"
          href={SUPPORT_CONTACT.whatsapp}
          target="_blank"
        >
          تماس از طریق واتس‌اپ
        </S.ClickableTextBlue>
      </S.ModalItem>
      <S.ModalItem>
        <S.Label>تلگرام:</S.Label>
        <S.ClickableTextBlue
          as="a"
          href={SUPPORT_CONTACT.telegram}
          target="_blank"
        >
          تماس از طریق تلگرام
        </S.ClickableTextBlue>
      </S.ModalItem>
      <Button
        variant="contained"
        onClick={onClose}
        sx={{
          marginTop: '16px',
          marginRight: 'auto', // دکمه در سمت چپ
          backgroundColor: ACTION_BLUE,
          color: '#FFFFFF',
          fontFamily: 'IRANYekanXFaNum',
          '&:hover': { backgroundColor: ACTION_BLUE_HOVER },
        }}
      >
        بستن
      </Button>
    </S.ModalContent>
  </Modal>
);

export default SupportModal;
